import transactionByStoreRouter from './transaction-by-store/routers';
import inventorySummaryRouter from './inventory-summary/routers';
import productRevenueReportRouter from '@/view/pages/product-revenue-report/routers';
import billRevenueReportRouter from './bill-revenue-report/routers';
import productImeiRevenueReportRouter from './product-imei-revenue-report/routers';
import salesReportsV2Router from './sales-reports/routers';

export default [
  {
    path: '/reports',
    component: () => import('./Reports.vue'),
    meta: {
      title: 'Báo cáo - CLICKBUY',
    },
    children: [
      ...transactionByStoreRouter,
      ...inventorySummaryRouter,
      ...productRevenueReportRouter,
      ...billRevenueReportRouter,
      ...productImeiRevenueReportRouter,
      ...salesReportsV2Router,
    ],
  },
];

